if (document.querySelectorAll('[data-component="hamburger"]').length > 0) {
    document.addEventListener('DOMContentLoaded', function () {

        const toggle = document.querySelector('[data-toggle="hamburger"]');
        const target = document.querySelector('.hamburger');
        const overlayTarget = document.querySelector('.hamburger-overlay');
        const dialogCloseTarget = document.querySelector('.hamburger-close__action');
        
        toggle.addEventListener('click', function () {
            target.classList.add('show');
        });
        
        overlayTarget.addEventListener('click', function () {
            target.classList.remove('show');
        });

        dialogCloseTarget.addEventListener('click', function () {
            target.classList.remove('show');
        })
    })
}